import { render, staticRenderFns } from "./account-site-stat.vue?vue&type=template&id=2fc09962&scoped=true"
import script from "./account-site-stat.vue?vue&type=script&lang=ts"
export * from "./account-site-stat.vue?vue&type=script&lang=ts"
import style0 from "./account-site-stat.vue?vue&type=style&index=0&id=2fc09962&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc09962",
  null
  
)

export default component.exports